import type { UserManager } from 'oidc-client-ts';

import Logger from '@/utils/logger';

import { config } from '../../config';
import * as storage from '../login/storage';
import { reportErrorToSentry } from './sentry';

const LOGGER_TAG = "Oauth config";

const saveCurrentRoute = () => {
  const initialRoute = [window.location.hash, window.location.search].join('').replace(/^#\/?/u, '');
  storage.routeStorage.saveRoute(initialRoute);
  Logger.trace(LOGGER_TAG, 'saving initial route', initialRoute);
};

export const attemptInitialSignIn = async (userManager: UserManager) => {
  const isFreshRedirect = window.location.href.includes('get-started');

  try {
    const user = await userManager.signinSilent();
    const initialRoute = storage.routeStorage.getRoute();

    Logger.trace(LOGGER_TAG, 'initialRoute lookup', initialRoute);

    if (initialRoute && isFreshRedirect) {
      Logger.trace(LOGGER_TAG, `Go to location "/${initialRoute}"`);
      window.location.replace(`#/${initialRoute}`);
    }

    storage.routeStorage.discardRoute();
    return await Promise.resolve(user);
  } catch (error) {
    Logger.trace(LOGGER_TAG, 'oidc.signinSilent failed, trying page redirect...', error);

    if (config.login.preventRedirect) {
      Logger.warn(LOGGER_TAG, 'Redirect prevented due to config.', error);
    } else if (isFreshRedirect) {
      Logger.trace(LOGGER_TAG, 'Redirect prevented due to supsicious signin error', error);
      storage.routeStorage.discardRoute();
      reportErrorToSentry(error);
    } else {
      saveCurrentRoute();
      userManager.signinRedirect();
    }

    Logger.trace(LOGGER_TAG, 'auth problem?', error);
    throw new Error('Need to sign in');
  }
};
